<template>
  <v-container fluid>
    <v-alert
      dense
      outlined
      elevation="1"	
      type="info"
      color="blue"
      class="pa-2"
    >
      <b>• Qualquer alteração realizada nesta ferramenta será aplicada de maneira <u class="cPrimary">individual</u> no sistema conectado. <u class="cPrimary">Para que as alterações sejam concluídas</u>, é necessário que os usuários realizem o <u class="cPrimary">logout</u> e, em seguida, efetuem o <u class="cPrimary">login</u> novamente no sistema.</b>
      <br><br>
      <b>• <u class="cPrimary">Em breve</u> será implementado na tela de listagem um botão para <u class="cPrimary">replicar as alterações em outras empresas</u>.</b>
    </v-alert>
    <base-material-card
      color="primary"
      icon="mdi-account-cog"
      inline
      class="ml-0 px-5 py-4"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Perfis de Usuários
        </div>
      </template>
      <v-btn
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float:left"
        relative
        text
        medium
        @click="$router.push('perfis/edit')"
      >
        <v-icon
          left
          size="30px"
        >
          mdi-plus-circle
        </v-icon>
        Novo Perfil
      </v-btn>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <v-divider class="mt-10" />
      <v-data-table
        :headers="headers"
        :items="item"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        no-data-text="Nenhum perfil disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.perfil`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                class="text-truncate-column"
                v-bind="attrs"
                v-on="on"
              >
                {{ item.perfil }}
              </div>
            </template>
            <span>{{ item.perfil }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <span
            style="font-weight: bold"
            :style="item.status ? 'color: green' : 'color: red'"
          >
            {{ item.status ? 'Sim' : 'Não' }}
          </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon 
                  small
                  :color="!item.status ? 'green' : 'red'"
                  v-bind="attrs" 
                  v-on="on"
                  @click="alterarStatus(item)"
                >
                  {{ item.status ? 'mdi-thumb-down-outline' : 'mdi-thumb-up-outline' }}
                </v-icon>
              </template>
              <span>{{ item.status ? "Inativar Perfil" : "Ativar Perfil" }}</span>
            </v-tooltip>
          </v-btn>
          <v-btn
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.push(`perfis/edit/${item.id}`)"
          >
            <v-icon small>
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:[`footer.page-text`]>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="$emit('rechargeTable')"
              >
                mdi-refresh
              </v-icon>
            </template>
            <span>Clique aqui para recarregar os perfis</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>
  
<script>
import PerfisService from '@/services/PerfisService';
import powerupsActionsMixins from '@/mixins/powerupsActionsMixins';
  
export default {
  mixins: [powerupsActionsMixins],
  
  props: {
    item: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  
  data: () => ({
    powerupService: PerfisService,
    powerupEntityName: 'Perfil do Usuário',
    search: '',
    headers: [
      {
        text: '#',
        value: 'id'
      },
      {
        text: 'Perfil',
        value: 'perfil'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        sortable: false,
        text: 'Ações',
        value: 'actions',
        class: 'pl-4'
      }
    ]
  }),
  
  methods: {
    alterarStatus(perfil) {
      PerfisService.atualizarStatus(perfil.id, !perfil.status)
        .then((response) => {
          this.$toast.success(response.data.msg, '', { position: 'topRight', timeout: 6000 });
          this.$emit('rechargeTable');
        })
        .catch(err => {
          if (err?.data?.error_code == 120) {
            this.$toast.error(err.data.erro, '', { position: 'topRight', timeout: 6000 });
          } else {
            this.$toast.error(`Erro ao alterar status do perfil [${perfil.perfil}].`, '', { position: 'topRight' });
            console.error(`Erro ao alterar status do perfil [${perfil.perfil}].`, err);
          }
        });
    }
  }
};
</script>